import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from "react";

interface OfferActionsContextValue {
  actions: ReactNode;
  isSticky: boolean;
  placement: "inline" | "sticky";
  setInlineActions: Dispatch<SetStateAction<HTMLDivElement | null>>;
}

export const OfferActionsContext =
  createContext<OfferActionsContextValue | null>(null);
OfferActionsContext.displayName = "OfferActionsContext";
